// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FBBiB11SH8wH1uQoSHwR{grid-template-rows:80px 1fr;height:100%;display:grid}.og8DYYAnDA52E3tivvmT{padding-bottom:100px;display:flex}._lN11g9fa8qZ00LmVA_x{flex-direction:column;flex-grow:1;justify-content:center;align-items:center;display:flex}._lN11g9fa8qZ00LmVA_x .Si_OjdimSIcacEk8eBtc{width:32px;height:32px;margin-bottom:16px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `FBBiB11SH8wH1uQoSHwR`,
	"emptyState": `og8DYYAnDA52E3tivvmT`,
	"content": `_lN11g9fa8qZ00LmVA_x`,
	"loading": `Si_OjdimSIcacEk8eBtc`
};
export default ___CSS_LOADER_EXPORT___;
